import { render, staticRenderFns } from "./custom_dashboard.vue?vue&type=template&id=24190e95&scoped=true"
import script from "./custom_dashboard.vue?vue&type=script&lang=js"
export * from "./custom_dashboard.vue?vue&type=script&lang=js"
import style0 from "./custom_dashboard.vue?vue&type=style&index=0&id=24190e95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24190e95",
  null
  
)

export default component.exports